import { connect, ConnectedProps } from 'react-redux';
import { StateType } from '../../../../state/state.types';

const mapState = ({
  queryParams,
  search,
  router: { location },
}: StateType) => ({
  type: queryParams.type,
  enableSnippets: search.enableSnippets,
  pathname: location.pathname,
  // @ts-expect-error: see https://doctrinelegal.atlassian.net/browse/INS-1865
  modalParam: location.query.modal,
  redirectToSearchRoute: search.redirectToSearchRoute,
});

export const Connect = connect(mapState);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
